import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { EntityUtils } from '@/common/utils/EntityUtils';
import { useCallback } from 'react';

export const IncDataSrcList = ({ polId }) => {
  const augRowsReq = useCallback(
    EntityUtils.parentFilterAugRowsReq('POL', polId),
    [polId]
  );

  return (
    <EntityList entity="INC_DATA_SRC" augRowsReq={augRowsReq} />
  );
};
